import React from 'react';
import { RouteComponentProps } from 'react-router';

import { FaqContainer } from '../../epic/faq';

export const Page: React.FC<RouteComponentProps> = () => {
  return <FaqContainer />;
};
